export const handleDownload = (prop) => {
    // Make a request to the backend public download endpoint
    fetch(`/api/download/${prop.downloadLink}`)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.blob();
        })
        .then(blob => {
            if (!blob) return;
            const url = URL.createObjectURL(blob);
            const downloadLink = document.createElement('a');
            downloadLink.href = url;
            downloadLink.download = prop.name;
            downloadLink.click();
            URL.revokeObjectURL(url);
        })
        .catch(error => {
            console.error('Error:', error);
        });
};

//create a function to delete a file
export const handleDelete = (prop, onDeleteSuccess) => {
    // Check if user is logged in
    const currentUser = localStorage.getItem("userName");
    if (!currentUser) {
        alert("Please log in to delete files");
        return;
    }

    // Make a request to the backend delete endpoint
    fetch(`/api/delete/${prop.downloadLink}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then(response => {
            if (response.status === 401) {
                alert("Please log in to delete files");
                return;
            }
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            onDeleteSuccess();
            console.log('Record deleted successfully!');
        })
        .catch(error => {
            console.error('Error deleting record:', error);
        });
}
